import styled from "styled-components"

export const PageWrapper = styled.div`
  min-height: 100vh;
  width: 100vw;
  background: var(--Schemes-Surface-Dark-Navy, #081c29);
  position: relative;
  overflow: hidden;
`

export const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 275px;
  background: linear-gradient(180deg, #05050C 0%, rgba(5, 5, 12, 0.00) 100%);
  pointer-events: none;
  z-index: 0;
`

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 44px 24px 60px;
  gap: 44px;
  min-height: 100vh;
  box-sizing: border-box;
  max-width: var(--app-max-width);
  margin: 0 auto;
`

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Title = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: #ffffff;
  margin: 0;
`

export const BodyTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const BodyText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`

export const DownloadCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  padding: 16px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const DownloadCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const DownloadCardText = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`

export const BadgesRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`

export const BadgeLink = styled.a`
  display: flex;
  text-decoration: none;
`

export const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
`

export const FooterHighlight = styled.span`
  color: #ffffff;
  white-space: nowrap;
`

export const FooterLink = styled.a`
  color: #2cccd3;
  text-decoration: none;
  display: inline;
`
